import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactS3Uploader from "react-s3-uploader"; // Lazy load this as it increases bundle size
import Dropzone from "react-dropzone";
import ajax from "superagent";
import WebcamCapture from "./WebcamCapture";
import ImageUploadAlert from "../../../ImageUploadAlert";
import { getCookie, withCartIdParam } from "../../../../utils/BrowserHelper";
const delImg = require("../../styles/delete.svg");
import ActiveIcon from "../vectors/ActiveIcon";
const selfieIcon = require("../../styles/selfie-icon.svg");
import PlaceHolderImg from "../vectors/PlaceHolderImg";

import { ReadStream } from "fs";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";
import UploadIcon from "../../../EventGalleryMobile/vectors/UploadIcon";
import SelfieIcon from "../../../EventGalleryMobile/vectors/SelfieIcon";

interface FilterByImageProps {
  updateFilter: Function;
  selectedImage: string | null;
  expanded: boolean;
  clearSelfie: Function;
  changeZindex: Function;
  collapseFilter: Function;
  similarity: number;
  isPhotoIndexingDisabled: boolean;
  getReferenceImage: () => string | null;
  photoBundleDiscountAvailed?: boolean;
  cartCount?: number;
  browsePhotosPath: string;
  isActive: boolean;
  setClearCartPopup: Function;
  pageConfig: {
    accentColor: string;
    primaryColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}

interface FilterByImageState {
  webcam: boolean;
  previewImage: any;
  uploadProgress: number;
  processing?: boolean;
}

class FilterByImage extends React.PureComponent<
  FilterByImageProps,
  FilterByImageState
> {
  static contextTypes = {
    selfieSearchS3Bucket: PropTypes.string,
    cartId: PropTypes.number,
    showPrepaidClearCartWarning: PropTypes.bool,
    promptClearPrepaidCart: PropTypes.func,
    hideUploadSelfie: PropTypes.bool,
    isEmbed: PropTypes.bool,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string
    })
  };
  uploadInput: any;

  constructor(props: FilterByImageProps) {
    super(props);

    this.state = {
      webcam: false,
      previewImage: this.props.selectedImage,
      uploadProgress: 0,
      processing: undefined
    };
  }

  getSignedUrl = (file: { type: any }, callback: (arg0: any) => void) => {
    ajax
      .get(withCartIdParam("/s3/signed_url", this.context.cartId))
      .query({
        bucket: this.context.selfieSearchS3Bucket,
        contentType: file.type
      })
      .then(data => {
        callback(JSON.parse(data.text));
      })
      .catch(error => {
        console.error(error);
      });
  };

  uploadAndFilter = (
    imageFile: string | number | boolean | Blob | Buffer | ReadStream
  ) => {
    this.setState({
      previewImage: URL.createObjectURL(imageFile),
      processing: true
    });
    //@ts-ignore
    (window.dataLayer || []).push({ event: "filterAlbumByImage" });

    ajax
      .post("/s3/upload_image")
      .attach("file", imageFile)
      .field("bucket", this.context.selfieSearchS3Bucket)
      .then(response => {
        this.props.updateFilter(response.body.url);
        this.props.trackFilterEvents("selfie");
      });
  };

  uploadBase64Image = (base64Img: RequestInfo) => {
    fetch(base64Img)
      .then(res => res.blob())
      .then(blob =>
        //@ts-ignore
        this.uploadAndFilter(new File([blob], { type: "image/png" }))
      );
  };

  imageSelected = (file: any, next: (arg0: any) => void) => {
    this.setState({
      previewImage: URL.createObjectURL(file),
      processing: true
    });
    next(file);
  };

  imageDropped = (accepted: any[], _: any) => {
    if (accepted[0]) {
      this.uploadAndFilter(accepted[0]);
    }
  };

  handleClearSelfie = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    event.stopPropagation();
    this.props.clearSelfie();
  };

  componentWillReceiveProps(nextProps: { selectedImage: string | null }) {
    //Check if the selectedImage has been updated, or if the cookie has been updated with a new image or if cookie has been deleted
    if (
      this.props.selectedImage != nextProps.selectedImage ||
      this.props.getReferenceImage() != null
    ) {
      this.setState({
        processing: false,
        previewImage: nextProps.selectedImage
      });
    }
  }

  toggleWebcam = () => {
    this.setState({
      webcam: !this.state.webcam
    });
    this.props.changeZindex();
  };

  cartHasBundlePhotos = () =>
    this.props.photoBundleDiscountAvailed &&
    this.props.cartCount &&
    this.props.cartCount > 0;

  clearCart = (e?: any) => (
    e && e.preventDefault(), this.props.setClearCartPopup(true)
  );

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingOne">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={selfieIcon} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapseOne"
              aria-expanded={this.props.expanded}
              aria-controls="collapseOne"
              onClick={e => this.props.collapseFilter(e, "selfie")}
            >
              Uploading a Selfie
            </a>
          </h4>
        </div>
        {this.props.isPhotoIndexingDisabled ? (
          <p className="geo-warning-info">
            <i className="fa fa-info-circle"></i> Selfie search is unavailable
            for this event
          </p>
        ) : (
          <div
            id="collapseOne"
            className={
              "panel-collapse collapse " + (this.props.expanded ? "in" : "")
            }
            role="tabpanel"
            aria-labelledby="headingOne"
          >
            <div className="panel-body">
              <div className="geo-ssupload-wrap">
                <b className="geo-ssupload-title">
                  It’s easy to find your photos!
                </b>
                <p className="geo-ssupload-text">
                  Simply upload a{" "}
                  <span className="geo-ssupload-text-highlight">selfie</span> to
                  view your matching photos instantly.
                </p>
              </div>
              <div
                className="dv-uploadselfie ns"
                onClick={(event: any) => {
                  if (this.cartHasBundlePhotos()) {
                    event.stopPropagation();
                    this.clearCart();
                  } else if (this.context.showPrepaidClearCartWarning) {
                    event.stopPropagation();
                    this.context.promptClearPrepaidCart();
                  }
                }}
              >
                <Dropzone
                  onDrop={(accepted: any[], _: any) =>
                    this.cartHasBundlePhotos()
                      ? this.clearCart()
                      : this.context.showPrepaidClearCartWarning
                      ? this.context.promptClearPrepaidCart()
                      : this.imageDropped(accepted, _)
                  }
                  multiple={false}
                  noClickBubbling={true}
                  accept="image/*"
                  className="dv-dragphoto"
                  activeClassName="dv-dragphoto-active"
                  disabled={
                    this.context.hideUploadSelfie ||
                    this.cartHasBundlePhotos() ||
                    this.context.showPrepaidClearCartWarning
                  }
                >
                  {this.state.previewImage ? (
                    <React.Fragment>
                      {this.state.processing ? null : (
                        <span className="div-del">
                          <span
                            className="pic-del-btn"
                            onClick={e => this.handleClearSelfie(e)}
                          >
                            <img src={delImg} />
                          </span>
                        </span>
                      )}
                      <img src={this.state.previewImage} />
                    </React.Fragment>
                  ) : (
                    <div style={{ cursor: "pointer" }}>
                      <PlaceHolderImg
                        color={this.props.pageConfig.primaryColor}
                        style={{ width: "75", height: "109" }}
                      />
                    </div>
                  )}

                  {this.state.processing ? (
                    <React.Fragment>
                      <div className="dv-loader">
                        <div className="dv-loader-inner">
                          <div className="cssload-spin-box" />
                        </div>
                      </div>

                      <div className="dv-progress">
                        <div
                          className="dv-progress-bar"
                          style={{ width: `${this.state.uploadProgress}%` }}
                        />
                      </div>
                    </React.Fragment>
                  ) : null}
                </Dropzone>

                {this.context.hideUploadSelfie ? (
                  <Fragment></Fragment>
                ) : (
                  <label className="btn btn-primary selfie-up-btn no-shade btn-100">
                    <UploadIcon
                      color={ContrastForegroundUtility.fgColor(
                        this.context.pageConfiguration.primaryColor
                      )}
                    />
                    Upload Selfie
                    <ReactS3Uploader
                      className={"dv-upload-input"}
                      style={{ display: "none" }}
                      onClick={(e: Event) => {
                        if (this.context.showPrepaidClearCartWarning) {
                          e.preventDefault();
                          this.context.promptClearPrepaidCart();
                        }
                        this.cartHasBundlePhotos()
                          ? this.clearCart(e)
                          : this.context.showPrepaidClearCartWarning
                          ? this.context.promptClearPrepaidCart()
                          : null;
                      }}
                      getSignedUrl={this.getSignedUrl}
                      accept="image/*"
                      preprocess={this.imageSelected}
                      onProgress={completedPercent => {
                        this.setState({ uploadProgress: completedPercent });
                      }}
                      onError={console.error}
                      onFinish={result => {
                        this.setState({ uploadProgress: 0 });
                        this.props.updateFilter(result.signedUrl.split("?")[0]);
                        this.uploadInput.value = null;
                        this.props.trackFilterEvents("selfie");
                      }}
                      uploadRequestHeaders={{
                        "x-amz-acl": "public-read"
                      }}
                      scrubFilename={filename =>
                        filename.replace(/[^\w\d_\-.]+/gi, "")
                      }
                      inputRef={cmp => (this.uploadInput = cmp)}
                      contentDisposition="auto"
                    />
                  </label>
                )}
                <a
                  href="#"
                  className="btn secondary-btn btn-100 webcam-component"
                  onClick={() =>
                    this.cartHasBundlePhotos()
                      ? this.clearCart()
                      : this.context.showPrepaidClearCartWarning
                      ? this.context.promptClearPrepaidCart()
                      : this.toggleWebcam()
                  }
                >
                  <SelfieIcon
                    color={ContrastForegroundUtility.fgColor(
                      this.context.pageConfiguration.secondaryColor
                    )}
                  />
                  Take a selfie
                </a>

                {this.state.webcam ? (
                  <WebcamCapture
                    closeWebcam={this.toggleWebcam}
                    captured={(base64Img: any) => {
                      this.toggleWebcam();
                      this.uploadBase64Image(base64Img);
                    }}
                  />
                ) : null}
              </div>
              <ImageUploadAlert />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FilterByImage;
